{
  "controls": {
    "back": "Indietro",
    "close": "Chiudi",
    "last": "Fatto",
    "next": "Avanti",
    "skip": "Salta tour"
  },
  "dashboard": {
    "greeting": {
      "title": "Benvenuto nella tua dashboard",
      "body": "Questa è la tua home — una panoramica rapida di opportunità, snipe e i tuoi reami principali."
    },
    "kpi": {
      "title": "Opportunità in tempo reale",
      "body": "Quanti flip redditizi hai disponibili ora in tutti i tuoi strumenti."
    },
    "topOpportunities": {
      "title": "Migliori opportunità",
      "body": "Anteprima dei migliori flip in tempo reale. Cambia scheda per vedere oggetti a vendita rapida o migliori acquisti."
    },
    "snipeAlerts": {
      "title": "Snipe recenti",
      "body": "Snipe attivati nell'ultimo ciclo di aggiornamento. Clicca per configurare nuovi alert."
    },
    "realmStats": {
      "title": "Reami top",
      "body": "I tuoi reami di vendita più forti ordinati per popolazione, aste o rapporto prezzi."
    },
    "quickActions": {
      "title": "Accesso rapido",
      "body": "Salta direttamente in qualsiasi strumento da qui."
    }
  },
  "flipping": {
    "dataFreshness": {
      "title": "Stato dei dati",
      "body": "Mostra quanto sono freschi i dati d'asta. La pagina si aggiorna automaticamente quando arrivano nuovi dati."
    },
    "filters": {
      "title": "Barra dei filtri",
      "body": "Filtra i risultati per reame, qualità, profitto, tasso di vendita e altro. Salva le combinazioni preferite come preset."
    },
    "stats": {
      "title": "Riepilogo investimento",
      "body": "Totali dei flip visibili: investimento richiesto, ricavi attesi e profitto al netto della commissione della casa d'aste."
    },
    "table": {
      "title": "Opportunità",
      "body": "Ogni riga è un flip: compra su un reame, vendi su un altro. Clicca un oggetto per copiarlo o aggiungerlo ai preferiti."
    },
    "pagination": {
      "title": "Paginazione",
      "body": "Naviga le pagine dei risultati e scegli quanti oggetti mostrare alla volta."
    }
  },
  "housing": {
    "dataFreshness": {
      "title": "Stato dei dati",
      "body": "Mostra quanto sono freschi i dati housing e quando è previsto il prossimo aggiornamento."
    },
    "filters": {
      "title": "Barra dei filtri",
      "body": "Filtra i flip housing per reame, profitto, tasso di vendita e tetto di buyout."
    },
    "stats": {
      "title": "Riepilogo investimento",
      "body": "Totali dei flip housing visibili per dimensionare il budget prima di acquistare."
    },
    "table": {
      "title": "Opportunità housing",
      "body": "Ogni riga è un oggetto housing economico su un reame e più prezioso su un altro."
    },
    "pagination": {
      "title": "Paginazione",
      "body": "Naviga le pagine e regola quanti risultati mostrare."
    }
  },
  "dropship": {
    "dataFreshness": {
      "title": "Stato dei dati",
      "body": "Mostra quanto sono freschi i dati dropship e quando arriverà il prossimo aggiornamento."
    },
    "filters": {
      "title": "Barra dei filtri",
      "body": "Filtra le opportunità di dropship per reame, qualità, espansione e redditività."
    },
    "stats": {
      "title": "Riepilogo investimento",
      "body": "Totali dei trade dropship visibili — utile per pianificare capitale e capacità."
    },
    "table": {
      "title": "Opportunità dropship",
      "body": "Ogni riga è un oggetto da comprare su un reame e rivendere su un altro con margine."
    },
    "pagination": {
      "title": "Paginazione",
      "body": "Naviga le pagine di risultati dropship."
    }
  },
  "inventory": {
    "realms": {
      "title": "Reami di vendita",
      "body": "Scegli i reami contro cui analizzare il tuo inventario."
    },
    "csv": {
      "title": "Incolla il tuo inventario",
      "body": "Incolla qui un CSV del tuo stock separato da punto e virgola — lo strumento cercherà trade cross-realm redditizi."
    },
    "analyze": {
      "title": "Analizza",
      "body": "Avvia l'analisi cross-realm sull'inventario appena incollato."
    },
    "results": {
      "title": "Consigli di flip",
      "body": "Ogni riga è un oggetto del tuo inventario che ora vale di più su un altro reame."
    },
    "export": {
      "title": "Esporta",
      "body": "Scarica l'analisi come CSV per usarla in un foglio di calcolo o in un addon."
    }
  },
  "stats": {
    "table": {
      "title": "Statistiche reame",
      "body": "Confronta prezzi d'asta, numero di annunci e tendenze su tutti i reami della tua regione."
    }
  },
  "tsm": {
    "filters": {
      "title": "Filtri",
      "body": "Scegli quali oggetti includere in base a categoria, espansione, qualità e profitto."
    },
    "table": {
      "title": "Elenco oggetti",
      "body": "Oggetti corrispondenti ai filtri — copiali direttamente in un'operazione TSM Price Source."
    },
    "pagination": {
      "title": "Paginazione",
      "body": "Naviga le pagine e scegli quanti oggetti mostrare alla volta."
    }
  },
  "snipe": {
    "tabs": {
      "title": "Categorie di alert",
      "body": "Passa tra snipe di oggetti, snipe di pet, token di WoW e regole iLvl."
    },
    "add": {
      "title": "Aggiungi nuovo alert",
      "body": "Aggiungi un oggetto, pet o regola alla tua watchlist — verrai avvisato appena scende sotto il prezzo obiettivo."
    },
    "list": {
      "title": "Alert attivi",
      "body": "I tuoi alert configurati con prezzi obiettivo e canali webhook assegnati."
    },
    "import": {
      "title": "Importazione in blocco",
      "body": "Importa un'intera lista in una volta: fai clic su Importa per scegliere un file, oppure incolla una lista copiata in qualsiasi punto di questa pagina. Vedrai un'anteprima prima che qualcosa venga salvato."
    },
    "inlineEdit": {
      "title": "Modifica i prezzi sul posto",
      "body": "Fai clic su un prezzo nella tabella per modificarlo direttamente — Invio salva, Esc annulla. Gli avvisi eliminati possono essere ripristinati con Annulla, e puoi ordinare la lista per nome o prezzo."
    }
  },
  "tsmProfile": {
    "video": {
      "title": "Video di configurazione",
      "body": "Guarda questo breve video per la guida completa alla configurazione del profilo TSM."
    },
    "min": {
      "title": "Prezzo minimo",
      "body": "Copia questa formula nell'operazione TSM di prezzo minimo."
    },
    "max": {
      "title": "Prezzo massimo",
      "body": "Copia questa formula nell'operazione TSM di prezzo massimo."
    },
    "normal": {
      "title": "Prezzo normale",
      "body": "Copia questa formula nell'operazione TSM di prezzo normale."
    }
  },
  "settingsRealm": {
    "region": {
      "title": "Regione",
      "body": "Scegli US o EU — controlla tutte le liste di reami nell'app."
    },
    "buying": {
      "title": "Reami di acquisto",
      "body": "I reami dove compri a prezzi bassi. Aggiungine quanti puoi raggiungere comodamente."
    },
    "selling": {
      "title": "Reami di vendita",
      "body": "I reami dove rivendi con profitto. Compaiono come destinazione in ogni strumento."
    },
    "accounts": {
      "title": "Account WoW",
      "body": "Se giochi su più account, registrali qui e assegna loro i reami."
    },
    "save": {
      "title": "Salva configurazione",
      "body": "Salva e il resto dell'app inizierà subito a usare questi reami."
    }
  },
  "settingsPersonal": {
    "preview": {
      "title": "Anteprima filtri",
      "body": "Anteprima in tempo reale dell'interfaccia dei filtri che vedrai negli strumenti di flipping."
    },
    "ranges": {
      "title": "Intervalli predefiniti",
      "body": "Imposta gli intervalli di profitto, tasso di vendita e prezzo da pre-applicare in ogni strumento."
    },
    "dashboard": {
      "title": "Soglie della dashboard",
      "body": "Controlla buyout minimo e massimo per le opportunità mostrate sulla dashboard."
    },
    "matching": {
      "title": "Match degli oggetti",
      "body": "Limita il match delle statistiche a determinate espansioni per prezzi cross-realm più accurati."
    },
    "save": {
      "title": "Salva predefiniti",
      "body": "Salva queste impostazioni come tuoi predefiniti personali su tutti gli strumenti."
    }
  },
  "rowActions": {
    "title": "Menu azioni riga",
    "body": "La prima colonna ora raggruppa la stella dei preferiti, la casella di selezione e la campana degli avvisi di snipe. Apri questo menu per selezionare o deselezionare la pagina corrente o tutto su tutte le pagine, mantenere solo i tuoi preferiti, oppure fissare in alto preferiti, obiettivi di snipe e righe selezionate. Anche le impostazioni delle colonne (trascina per riordinare, mostra/nascondi) vivono qui."
  },
  "settingsDiscord": {
    "link": {
      "title": "Collega Discord",
      "body": "Connetti il tuo account Discord così il bot può inviarti alert e notifiche."
    },
    "verification": {
      "title": "Verifica DM",
      "body": "Richiedi un codice a 6 cifre per confermare che il bot può raggiungerti via DM."
    },
    "notifications": {
      "title": "Impostazioni notifiche",
      "body": "Abilita le notifiche via DM per gli aggiornamenti di regione e altri eventi."
    },
    "webhooks": {
      "title": "Categorie webhook",
      "body": "Crea categorie webhook per instradare gli alert snipe a canali Discord specifici."
    }
  },
  "classicDeals": {
    "controls": {
      "title": "Classic Deals",
      "body": "Pick your region and realms, then find same-realm undercut opportunities."
    },
    "table": {
      "title": "Deals",
      "body": "Each row is an item you can buy at the lowest price and relist just under the next-cheapest listing on the same realm."
    }
  },
  "filterMode": {
    "title": "Filtra o ricalcola",
    "body": "Scegli cosa succede quando modifichi un filtro: «Filtra» restringe all'istante i risultati già caricati, «Ricalcola» recupera risultati aggiornati dal server."
  }
}
